/* MAGIJOUETS – audio reviews (sections/mj-voices).
   v17 (2026-10-10, speed): moved from the inline <script> of sections/mj-voices.liquid, which now loads this file with defer at
   the same place. The browser and Shopify's CDN keep it in cache, so it is no longer downloaded again inside every page.
   Asset files cannot hold Liquid. */
(function () {
  function fmt(s) { if (!isFinite(s) || s < 0) return '0:00'; s = Math.round(s); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function init(root) {
    if (!root || root.__mjVo) return; root.__mjVo = true;
    root.classList.add('is-js');
    var notes = Array.prototype.slice.call(root.querySelectorAll('[data-note]'));
    notes.forEach(function (note) {
      var a = note.querySelector('[data-audio]'), btn = note.querySelector('[data-play]'), seek = note.querySelector('[data-seek]'),
          bars = note.querySelectorAll('[data-wave] i'), time = note.querySelector('[data-time]');
      if (!a || !btn) return;
      a.removeAttribute('controls');
      function paint() {
        var d = a.duration, p = d > 0 ? a.currentTime / d : 0, done = Math.round(p * bars.length);
        for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('is-done', i < done);
        if (seek && document.activeElement !== seek) seek.value = String(Math.round(p * 1000));
        if (seek) seek.setAttribute('aria-valuetext', fmt(a.currentTime) + ' sur ' + fmt(d));
        time.textContent = (!a.ended && (!a.paused || a.currentTime >= 1)) ? fmt(a.currentTime) : fmt(d);
      }
      a.addEventListener('loadedmetadata', paint);
      a.addEventListener('durationchange', paint);
      a.addEventListener('timeupdate', paint);
      a.addEventListener('play', function () { note.classList.add('is-playing'); btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace('Écouter', 'Mettre en pause')); });
      a.addEventListener('pause', function () { note.classList.remove('is-playing'); btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace('Mettre en pause', 'Écouter')); });
      a.addEventListener('ended', function () { a.currentTime = 0; paint(); });
      a.addEventListener('error', function () { a.pause(); note.classList.add('is-broken'); });
      btn.addEventListener('click', function () {
        if (a.paused) {
          notes.forEach(function (o) { var x = o.querySelector('[data-audio]'); if (x && x !== a && !x.paused) x.pause(); });
          var pr = a.play(); if (pr && pr.catch) pr.catch(function () {});
        } else a.pause();
      });
      if (seek) seek.addEventListener('input', function () { if (a.duration > 0) { a.currentTime = a.duration * (Number(seek.value) / 1000); paint(); } });
      if (a.error) note.classList.add('is-broken');
      paint();
    });
    // v16 (perf): the recordings are preload="none" (nothing is downloaded with the page); their length is fetched
    // only when the section comes within 600 px of the screen. A tap on play always loads and plays at once.
    var near = function () {
      notes.forEach(function (n) {
        var x = n.querySelector('[data-audio]');
        if (x && x.paused && x.readyState === 0 && !x.error && x.preload === 'none') { x.preload = 'metadata'; try { x.load(); } catch (e) {} }
      });
    };
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); near(); } }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else near();
    root.__mjVoStop = function () { if (io) io.disconnect(); notes.forEach(function (n) { var x = n.querySelector('[data-audio]'); if (x) x.pause(); }); };
  }
  document.querySelectorAll('[data-mj-vo]').forEach(init);
  if (!window.__mjVoBound) {
    window.__mjVoBound = true;
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-mj-vo]'); if (r) init(r); });
    document.addEventListener('shopify:section:unload', function (e) { var r = e.target && e.target.querySelector('[data-mj-vo]'); if (r && r.__mjVoStop) r.__mjVoStop(); });
  }
})();
